import { parseInt } from 'lodash'

export default {
    methods: {
        parseCustomerContact(contact) {
            if (contact === '-') {
                return contact
            }

            const array = [
                contact.firstName,
                contact.lastName,
                contact.phoneNumber,
                contact.email,
            ]

            const filteredArray = array.filter(item => {
                return item != null && item.length != 0
            })

            let contactStr = ''

            filteredArray.forEach((item, index) => {
                filteredArray.length != index + 1 && index !== 0 ? contactStr += `${item}, ` : contactStr += `${item} `
            })

            return contactStr
        },
        parseUserInitials(username) {
            let initials = ''

            username.split(' ').forEach(item => {
                initials += item.charAt(0)
            })

            return initials
        },
        parseFileName(fileName) {
            const words = fileName.split('/')

            return words[words.length-1]
        },
        parseColorsValue(data) {
            const colors = data.map(item => item.name)

            return colors.length ? colors : null
        },
        parseEmptyValue(value) {
            if (typeof value === 'string' || value instanceof String) {
                return value.toString().trim() || '-'
            }

            return value?.toString()?.trim() ? value : '-'
        },
        parseBooleanValue(value) {
            if (value === true) return 'tak'
            if (value === false) return 'nie'

            return '-'
        },
        parseEmptyNumberValue(value) {
            return !isNaN(parseInt(value)) ? value : 0
        },
        parseEmptyStringToNull(value) {
            if (typeof value === 'string') {
                return value.length > 0 ? value : null
            } else {
                return value
            }
        }
    }
}
